import React from 'react';
import { ButtonWithLoading } from '@spark/ui-components/components/Button';
import Icon from '@spark/ui-components/components/Icon';
import Tooltip from '@spark/ui-components/components/Tooltip';
import TruncatedText from '@spark/ui-components/components/TanStackTable/components/TruncatedText';

const renderTextWithTooltip = (value, maxLength) => {
  const text = value || '-';
  if (text === '-') {
    return text;
  }

  return (
    <Tooltip dir="top" text={text}>
      <div style={{ cursor: 'pointer' }}>
        <TruncatedText value={text} maxLength={maxLength} />
      </div>
    </Tooltip>
  );
};

export const getInfracaoColumns = (onEdit, onDelete, loadingEditId, loadingDeleteId) => [
  {
    id: 'id',
    accessorKey: 'id',
    header: 'ID',
    size: 80,
    cell: ({ row }) => row.original.id ?? '-'
  },
  {
    id: 'descricao',
    accessorKey: 'descricao',
    header: 'Descricao',
    size: 220,
    cell: ({ row }) => renderTextWithTooltip(row.original.descricao, 40)
  },
  {
    id: 'descricaoGrupo',
    accessorKey: 'descricaoGrupo',
    header: 'Descricao Grupo',
    size: 200,
    cell: ({ row }) => renderTextWithTooltip(row.original.descricaoGrupo, 35)
  },
  {
    id: 'descricaoPlanoAcao',
    accessorKey: 'descricaoPlanoAcao',
    header: 'Descricao Plano Acao',
    size: 200,
    cell: ({ row }) => renderTextWithTooltip(row.original.descricaoPlanoAcao, 35)
  },
  {
    id: 'porcentagemDesconto',
    accessorKey: 'porcentagemDesconto',
    header: '% Desconto',
    size: 120,
    cell: ({ row }) => {
      const value = row.original.porcentagemDesconto;
      return value === null || value === undefined ? '-' : `${value}%`;
    }
  },
  {
    id: 'acoes',
    header: 'Acoes',
    size: 120,
    cell: ({ row }) => (
      <div style={{ display: 'flex', gap: 8 }}>
        <Tooltip dir="top" text="Editar">
          <span className="d-inline-block">
            <ButtonWithLoading
              variant="outline-primary"
              size="sm"
              loading={loadingEditId === row.original.id}
              disabled={loadingEditId === row.original.id}
              onClick={(event) => {
                event.stopPropagation();
                onEdit(row.original.id);
              }}
            >
              <Icon name="pencil" size={16} />
            </ButtonWithLoading>
          </span>
        </Tooltip>
        <Tooltip dir="top" text="Excluir">
          <span className="d-inline-block">
            <ButtonWithLoading
              variant="outline-danger"
              size="sm"
              loading={loadingDeleteId === row.original.id}
              disabled={loadingDeleteId === row.original.id}
              onClick={(event) => {
                event.stopPropagation();
                onDelete(row.original.id);
              }}
            >
              <Icon name="trash" size={16} />
            </ButtonWithLoading>
          </span>
        </Tooltip>
      </div>
    ),
    enableSorting: false
  }
];
